import $ from 'jquery';
require('./shared/layout');

window.addEventListener("load", function () {

  var inputs = $('.form_input input[data-input]')
  var selects = $('.form_input select[data-input]')

  var est_hash = {
    freq: 0,
    viewers: 0,
    duration: 0,
    bitrate: 0
  }

  inputs.each(function (i, input) {
    var el = $(input)
    var prop = input.dataset.input
    est_hash[prop] = Number(this.value)

    var oninputchanged = function () {
      // var prop = this.dataset.input
      var value = Number(this.value)
      est_hash[prop] = value
      onchange()
      // console.log('input', this.value)
    }
    el.on('change', oninputchanged)
    el.on('keypress', oninputchanged)
    el.on('keyup', oninputchanged)
  })

  selects.each(function (i, input) {
    var el = $(input)
    var prop = input.dataset.input
    est_hash[prop] = Number(this.value)
    el.on('change', function () {
      // var prop = this.dataset.input
      var value = Number(this.value)
      est_hash[prop] = value
      onchange()
      // console.log('select', this.value)
    })
  })

  setTimeout(onchange, 0);

  function toggleDurationVisibility(is_enabled) {
    var durationInput = $('input[data-input="duration"')
    if (is_enabled) {
      durationInput.removeAttr('disabled')
      durationInput.parent().removeClass('disabled')
    } else {
      durationInput.attr('disabled')
      durationInput.parent().addClass('disabled')
    }
  }

  function onchange() {
    var show_duration = est_hash['freq'] !== -1
    toggleDurationVisibility(show_duration)

    // calc usage
    // console.log('est_hash', est_hash)
    var minutes = est_hash.viewers
    var bytes = (est_hash.bitrate * 1000) / 8
    bytes *= est_hash.viewers

    if (est_hash.freq === -1) {
      bytes *= 740 * 3600 // 740 hours
      minutes = 740 * 60
    } else {
      bytes *= est_hash.freq
      bytes *= est_hash.duration * 60

      minutes *= est_hash.freq * est_hash.duration
    }

    var unit = 'GB'
    var usage = bytes / Math.pow(1000, 3)
    if (usage > 1000) {
      unit = 'TB'
      usage = Number((usage / 1000).toFixed(3))
    }

    var usageBandwidthEL = $('[data-result-usage="bandwidth"]')
    $('[data-value]', usageBandwidthEL).text(usage)
    $('[data-unit]', usageBandwidthEL).text(unit)

    var usageMinsEL = $('[data-result-usage="minutes"]')
    $('[data-value]', usageMinsEL).text(minutes)
    // $('[data-unit]', usageMinsEL).text(unit)

    // choosePlan(usage, unit)
    choosePlan(bytes)
  }

  function choosePlan(bytes) {
    var plans = [
      {
        "name": "Event Plan",
        "cost": 49,
        "planDuration": 30,
        "bytes": 1000*Math.pow(1000,3)
      },
      // {
      //   "name": "25GB Livestream CDN Trial",
      //   "cost": 0,
      //   "planDuration": 7,
      //   "bytes": 25*Math.pow(1000,3)
      // },
      {
        "name": "Growth Plan",
        "cost": 119,
        "planDuration": 30,
        "bytes": 3000*Math.pow(1000,3)
      },
      {
        "name": "Scale Plan",
        "cost": 249,
        "planDuration": 30,
        "bytes": 6000*Math.pow(1000,3)
      },
      {
        "name": "Agency Plan",
        "cost": 369,
        "planDuration": 360,
        "bytes": 10000*Math.pow(1000,3)
      },
      // {
      //   "name": "4.8TB Bandwidth (Yearly)",
      //   "cost": 396,
      //   "planDuration": 360,
      //   "bytes": 4800*Math.pow(1000,3)
      // },
      // {
      //   "name": "24TB Bandwidth (Yearly)",
      //   "cost": 1512,
      //   "planDuration": 360,
      //   "bytes": 24000*Math.pow(1000,3)
      // },
      // {
      //   "name": "12TB (12000GB) Bandwidth (Yearly)",
      //   "cost": 792,
      //   "planDuration": 360,
      //   "bytes": 12000*Math.pow(1000,3)
      // },
      // {
      //   "name": "18TB Bandwidth (Yearly)",
      //   "cost": 1152,
      //   "planDuration": 360,
      //   "bytes": 18000*Math.pow(1000,3)
      // }
    ]

    var planSuggested = null
    for (const plan of plans) {
      if (plan.planDuration === 360) continue;
      if (bytes < plan.bytes) {
        planSuggested = plan
        break;
      }
    }

    // console.log('bytes', bytes)
    // console.log('plan', planSuggested)
    var platCostRecommendationEl = $('[data-recommendation-cost]')
    var platNameRecommendationEl = $('[data-recommendation-plan]')
    if (planSuggested) {
      $('[data-value]', platNameRecommendationEl).text(planSuggested.name)
      $('[data-value]', platNameRecommendationEl).show()

      $('[data-value]', platCostRecommendationEl).text(planSuggested.cost)
      // $('[data-unit].unit-alt', platCostRecommendationEl).text(planSuggested.planDuration === 30 ? 'per month' : 'per year')
      $('[data-unit].unit-alt', platCostRecommendationEl).text('per month')
      $('[data-unit]', platCostRecommendationEl).show()

      $("#calculator_cta").show()
      $("#calculator_cta_alt").hide()
    } else {
      var tbs = bytes / Math.pow(1000, 4)
      // var customCost = tbs * 50
      var customCost = Math.round(tbs * 33)
      // $('[data-value]', platNameRecommendationEl).hide()
      $('[data-value]', platNameRecommendationEl).text('Custom Plan')
      $('[data-value]', platCostRecommendationEl).text(customCost)
      // $('[data-value]', platCostRecommendationEl).text('Custom Price')
      // $('[data-unit]', platCostRecommendationEl).hide()
      $("#calculator_cta").hide()
      $("#calculator_cta_alt").show()

      if (est_hash.freq === 1) {
        $('[data-unit].unit-alt', platCostRecommendationEl).text('one time')
      } else {
        $('[data-unit].unit-alt', platCostRecommendationEl).text('per month')
      }
    }
  }
});

